<template>
    <div>
        <div
            v-if="withText"
            id="logo-studydrive-text"
            class="logo logo-studydrive-text mx-auto hidden md:block w-56 h-12"
            alt="Studydrive"
        ></div>
        <div
            id="logo-studydrive"
            :class="[
                { 'block md:hidden': withText },
                shouldShowPremiumLogo ? 'logo-studydrive-premium' : 'logo-studydrive',
                'h-12 w-12 logo mx-auto',
            ]"
            alt="Studydrive"
        ></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'TheLogo',
    props: {
        /**
         *  Should enable the logo with text on tablet or bigger
         */
        withText: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters('auth', ['user']),
        shouldShowPremiumLogo() {
            return this.user?.is_premium_system_enabled && this.user?.is_premium;
        },
    },
};
</script>
